import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { ReportAddTaskData } from "@/shared/components/ReportAddTask/models/ReportAddTaskData.model";
import { MAX_WIDTH_MODALS } from "@/modules/Profile/constants/ProfileConstants";
import { REPORT_ADD_TASK } from "@/shared/components/ReportAddTask/constants/ReportAddTaskConstants";

Vue.use(Vuetify);
@Component({
  name: "ReportAddTask"
})
export default class ReportAddTask extends Vue {
  @Prop() private activeModal!: boolean;
  @Prop() private dataReport!: Array<ReportAddTaskData>;

  reportTask: Array<ReportAddTaskData> = [];
  masiveTaskResponse = false;
  cardClass = STYLE_CLASSES.CARD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  MAX_WIDTH = MAX_WIDTH_MODALS;
  REPORT_ADD_TASK = REPORT_ADD_TASK;

  mounted() {
    this.reportTask = [];
    this.masiveTaskResponse = this.activeModal;
    this.reportTask = this.dataReport;
  }

  closeModal() {
    this.reportTask = [];
    this.masiveTaskResponse = false;
    this.$emit(REPORT_ADD_TASK.EMIT_EVENT);
  }
}
